import { __awaiter, __generator } from "tslib";
import { getMaxApplePayVersion } from './getMaxApplePayVersion';
import { reduceNetworksToSupported } from './reduceNetworksToSupported';
export var startApplePaySession = function (_a) {
    var request = _a.request, onCancel = _a.onCancel, onDone = _a.onDone, onValidateMerchant = _a.onValidateMerchant, onAuthorizePayment = _a.onAuthorizePayment;
    if (!ApplePaySession.canMakePayments()) {
        throw new Error('Apple Pay is not available');
    }
    var version = getMaxApplePayVersion();
    var requestSafe = reduceNetworksToSupported(version, request);
    var session = new ApplePaySession(version, requestSafe);
    if (onCancel) {
        session.oncancel = onCancel;
    }
    session.onvalidatemerchant = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var merchantSession, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, onValidateMerchant(event.validationURL)];
                case 1:
                    merchantSession = _a.sent();
                    session.completeMerchantValidation(merchantSession);
                    return [3, 3];
                case 2:
                    e_1 = _a.sent();
                    console.error('[Apple Pay] Error validating merchant', e_1);
                    session.abort();
                    if (onCancel) {
                        onCancel();
                    }
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    session.onpaymentauthorized = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var status_1, e_2, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    status_1 = ApplePaySession.STATUS_SUCCESS;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, onAuthorizePayment(event.payment.token)];
                case 2:
                    _a.sent();
                    return [3, 4];
                case 3:
                    e_2 = _a.sent();
                    console.error('[Apple Pay] Payment failed', e_2);
                    status_1 = ApplePaySession.STATUS_FAILURE;
                    return [3, 4];
                case 4:
                    session.completePayment(status_1);
                    if (onDone) {
                        onDone();
                    }
                    return [3, 6];
                case 5:
                    e_3 = _a.sent();
                    console.error('[Apple Pay] Error authorizing payment', e_3);
                    session.abort();
                    if (onCancel) {
                        onCancel();
                    }
                    return [3, 6];
                case 6: return [2];
            }
        });
    }); };
    session.begin();
    return session;
};
